import React         from 'react';
import ReactDom      from 'react-dom';

import Const         from 'fw_const';
import Utils         from 'utils';

import ContentsModal from 'contents_modal';

import {Tooltip}        from 'pui-react-tooltip';
import {OverlayTrigger} from 'pui-react-overlay-trigger';
// -------------------------------------------------------

class MultiAction extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      loading : false,
    };
  }
  // -------------------------------------------------------
  
  componentWillReceiveProps(nextProps) {
    if( nextProps.insta_user_id != this.props.data.insta_user_id ){
      this.setState({ loading: true });
      
      setTimeout( function(){
        this.setState({ loading: false });
      }.bind(this), 10);
    }
  }
  // -------------------------------------------------------
  
  action() {
    let insta_user_id = this.props.data.insta_user_id;
    
    let multi = this.props.base.multi_select;
    if( multi == undefined ) multi = [];
    
    if( multi.indexOf(insta_user_id) == -1 ){
      multi.push(insta_user_id);
    } else {
      multi = multi.filter((id) => { if( id != insta_user_id ) return id; });
    }
    
    this.props.base.event.updateData.bind(this)('multi_select', multi);
  }
  // -------------------------------------------------------
  
  render() {
    if( this.state.loading == true ) return null;
    
    let data = this.props.data;
    if( data.is_not_import_action === true ) return null;
    
    let insta_user_id = this.props.data.insta_user_id;
    
    let multi = this.props.base.multi_select;
    if( multi == undefined ) multi = [];
    
    let flg = (multi.indexOf(insta_user_id) >= 0);
    return (
      <div className="influencer-multi-action">
        <div className="checkbox-frame">
          {( flg )
            ? <input type="checkbox" id={insta_user_id} ref={(input) => { this.item = input }} onChange={this.action.bind(this)} className="checkbox" defaultChecked />
            : <input type="checkbox" id={insta_user_id} ref={(input) => { this.item = input }} onChange={this.action.bind(this)} className="checkbox" />
          }
          <label className="checkbox" htmlFor={insta_user_id}>複数選択</label>
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default MultiAction;